import { Controller } from "@hotwired/stimulus"

// This controller accepts events from the other Stimulus controllers to update the selection in the form.
export default class extends Controller {
  static get values() {
    return {
      name: String,
      domains: { type: Array, default: [] },
      selectedDomains: { type: Object, default: {} },
      hasLists: { type: Boolean, default: true },
    }
  }

  static get targets() {
    return ["domainsInput", "selectionTitle", "selectionDescription", "radioLabel"]
  }

  setFormByListType() {
    const newListName = document.getElementById("bic-import-new-list-name")
    const existingListName = document.getElementById("bic-import-list-name")
    const selectedListType = document.querySelector('input[name="import_list_type"]:checked').value

    if (selectedListType === "existing") {
      existingListName.setAttribute("required", "required")
      newListName.removeAttribute("required")
    } else {
      existingListName.removeAttribute("required")
      newListName.setAttribute("required", "required")
    }
  }

  updateSelection({ detail: { selectedDomains } }) {
    this.selectedDomainsValue = selectedDomains
    const numberOfDomains = Object.keys(selectedDomains).length
    const companyNames = Object.values(selectedDomains).slice(0, 5)
    const labelKey = this.hasListsValue ? "select_list" : "name_list"

    if (numberOfDomains > 0) {
      this.selectionTitleTarget.innerText = i18n.t("js.back.sidepanel.leads.title", {
        count: numberOfDomains,
        number: i18n.numberToDelimited(numberOfDomains),
      })
      this.radioLabelTarget.innerText = i18n.t(`js.back.sidepanel.leads.${labelKey}`, { count: numberOfDomains })
      const companyName = i18n.t("js.back.sidepanel.leads.description", {
        count: numberOfDomains - companyNames.length,
        number: i18n.numberToDelimited(numberOfDomains - 5),
        company_names: companyNames.join(", "),
      })
      this.selectionDescriptionTarget.innerText = companyName
      this.domainsInputTarget.value = Object.keys(selectedDomains).join(",")
    } else {
      this.selectionTitleTarget.innerText = i18n.t("js.back.sidepanel.leads.title", {
        count: this.domainsValue.length,
        number: i18n.numberToDelimited(this.domainsValue.length),
      })
      this.radioLabelTarget.innerText = i18n.t(`js.back.sidepanel.leads.${labelKey}`, {
        count: this.domainsValue.length,
      })
      this.selectionDescriptionTarget.innerText = this.nameValue
      this.domainsInputTarget.value = this.domainsValue.join(",")
    }
  }
}
